import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IBooking } from '../../interfaces/booking.interface';
import { getETA } from '../../utils/bookings';
import ItemData from './Item';
import { DELIVERING, PICKING } from '../../const/booking.constants';
import { EBookingStatus } from '../../enums/booking.enum';

const ETA: FC<Partial<IBooking>> = ({
    estimatedTimeToPointA = 0,
    estimatedTimeToPointB = 0,
    statusUpdates = [],
    statusText = '',
}) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });

    const isPicking = PICKING.includes(statusText as EBookingStatus);
    const isDelivering = DELIVERING.includes(statusText as EBookingStatus);

    const ETA = getETA(
        estimatedTimeToPointA,
        estimatedTimeToPointB,
        statusUpdates,
        isPicking,
        isDelivering,
    );

    return (
        <ItemData
            label={t('ETA')}
            info
            infoLabel={t('ETA_DETAILS', { point: t(isPicking ? 'THE_STORE' : 'THE_CLIENT') })}
            value={`${ETA || 0} min`}
        />
    );
};
export { ETA };
